<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
            <div class="mt--2 pb-2">
                <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
            </div>
          <h3 class="mb-0 text-center">
            Details sur la Validation et la prestation
          </h3>
        </div>
      </div>
      <div class="" :class="[ mobileView ? 'pt-3': 'card-body']">
        <div class="" :class="[ mobileView ? '': 'container']">
          <!--<b-row class="">
            <b-col sm="7" class="text-left" v-if="can">
              <b-button
                variant="primary"
                class="mb-2"
                size="sm"
                @click="ImprimerFacture"
              >
                {{ $t("message.print") }} {{ $tc("message.facture", 1) }}
              </b-button>
              <b-button
                class="mb-2"
                variant="primary"
                @click="ImprimerFactureProforma"
                size="sm"
              >
                {{ $t("message.imprimerProforma") }}
              </b-button>
              <b-button
                class="mb-2"
                variant="primary"
                @click="ImprimerFacture"
                size="sm"
              >
                {{ $t("message.imprimerDefinitive") }}
              </b-button>
            </b-col>
            <b-col sm="5" class= '' :class="{'text-right': !mobileView}" v-if="can">
              <b-button
                variant="outline-dark"
                class="mb-2"
                size="sm"
                @click="mailRecouvrementFacture"
              >
                {{ $t("message.recouvrer") }}
              </b-button>
              <b-button
                variant="outline-dark"
                class="mb-2"
                size="sm"
                @click="mailRappelFacture"
              >
                {{ $t("message.rappeler") }}
              </b-button>
              <b-button
                variant="outline-warning"
                size="sm"
                class="mb-2"
                @click="updateFacture"
              >
                {{ $t("message.edit") }}
              </b-button>
              <b-button
                variant="outline-danger"
                class="mb-2"
                size="sm"
                v-b-modal.delete-modal
              >
                {{ $t("message.delete") }}
              </b-button>
              <b-button variant="dark" class="mb-2" @click="mailRappelFacture">
                  {{ $t('message.rappeler') }}
              </b-button>

              <b-button variant="danger" v-b-modal.delete-modal>
                  {{ $t('message.delete') }}
              </b-button>

            </b-col>
          </b-row> -->
          <b-modal
            id="delete-modal"
            size="sm"
            header-bg-variant="danger"
            header-text-variant="light"
            :title="$t('message.delete') + ' ' + $tc('message.facture', 1)"
            hide-footer
          >
            <div class="d-block text-center">
              <h3>
                {{ $t("message.delete") }} {{ mFacture.date_facturation }}?
              </h3>
            </div>

            <div class="d-block float-right">
              <b-button variant="danger" @click="deleteFacture">
                {{ $t("message.delete") }}
              </b-button>

              <b-button
                variant="secondary"
                @click="$bvModal.hide('delete-modal')"
              >
                {{ $t("message.cancel") }}
              </b-button>
            </div>
          </b-modal>
        </div>
        <b-container>

          <b-row>
            <div class=" " :class="[ mobileView ? 'col-22': 'col-12']">
              <div class="timeline-box h-100">
                <div class="box-title text-center">
                  {{ $t("message.detailsValidation") }}
                </div>
                <div class=" " :class="{'box-content': !mobileView}">
                  <div
                    class="
                      box-item
                      column-display-style column-display-style-without-mb
                    "
                  >
                    <div class="row">
                      <div class="col-6" :class="{'text-right': !mobileView}">
                        <p>
                          <strong>{{ $t("message.nomEtablissement") }}</strong>
                        </p>
                      </div>
                      <div class="col-6" :class="{'text-left': !mobileView}">
                        <p>{{ etablissement }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6" :class="{'text-right': !mobileView}">
                        <p>
                          <strong>{{ $t("message.nomPatient") }}</strong>
                        </p>
                      </div>
                      <div class="col-6" :class="{'text-left': !mobileView}">
                        <p>{{ patientName }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6" :class="{'text-right': !mobileView}">
                        <p>
                          <strong>{{ $t("message.dateFacturation") }}</strong>
                        </p>
                      </div>
                      <div class="col-6" :class="{'text-left': !mobileView}">
                        <p>{{ formattedDate(mFacture.date_facturation) }}</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6" :class="{'text-right': !mobileView}">
                        <p>
                          <strong>{{ $t("message.status") }}</strong>
                        </p>
                      </div>
                      <div class="col-6" :class="{'text-left': !mobileView}">
                        <p>{{ getStatut(mFacture.statut) }}</p>
                      </div>
                    </div>
                    <div class="row" v-if="mFacture.statut == 'Rejeté'">
                      <div class="col-6" :class="{'text-right': !mobileView}">
                        <p>
                          <strong>{{ $tc("message.reasons", 2) }}</strong>
                        </p>
                      </div>
                      <div class="col-6" :class="{'text-left': !mobileView}">
                        <p>{{ mFacture.motif }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box-footer"></div>
              </div>
            </div>
            <!--                        <div class="col-6">-->
            <!--                            <div class="timeline-box h-100">-->
            <!--                                <div class="box-title">-->
            <!--                                    <i class="fa fa-money-bill" aria-hidden="true"></i>-->
            <!--                                    {{ $t('message.amount') }}-->
            <!--                                </div>-->
            <!--                                <div class="box-content">-->
            <!--                                    <div class="box-item">-->
            <!--                                        <div class="row">-->
            <!--                                            <div class="col-6 text-right">-->
            <!--                                                <p><strong>{{ $t('message.totalHorsRemise') }}</strong></p>-->
            <!--                                                <p><strong>{{ $t('message.remise') }}</strong></p>-->
            <!--                                                <p style="margin-top: 20px"><strong class="medsur-primary-color">{{ $t('message.totalAvecRemise') }}</strong></p>-->
            <!--                                            </div>-->
            <!--                                            <div :class="`${Number(mFacture.total_hors_remise) >= 100000 ? 'col-4' : 'col-3'} text-right`">-->
            <!--                                                <p>{{ displayNumber(mFacture.total_hors_remise) }}</p>-->
            <!--                                                <p>{{ displayNumber(mFacture.remise) }}</p>-->
            <!--                                                <p><strong class="total-amount medsur-primary-color m-0">{{ displayNumber(mFacture.total_avec_remise) }}</strong></p>-->
            <!--                                            </div>-->
            <!--                                        </div>-->

            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                                <div class="box-footer">-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </div>-->
          </b-row>

          <p class="heading text-center mt-5">
            {{ $t("message.prestationDetail") }}
          </p>
        <div v-if="!mobileView">
          <b-row v-if="examens.length > 0" class="my-2">
            <b-col sm="12">
              <b-table
                striped
                responsive
                hover
                bordered
                :items="examens"
                :fields="examensField"
              >
                <template v-slot:cell(name)="data">
                  <p class="mb-0 capitalize-first-letter">{{ data.value }}</p>
                </template>

                <template v-slot:cell(price)="data">
                  <p class="mb-0 capitalize-first-letter">
                    {{ displayNumber(data.value) }}
                  </p>
                </template>

                <template v-slot:cell(action)="data" v-if="this.$route.query.activeTab == 'examen'">
                  <div class="custom-control custom-checkbox mb-3" v-if="data.item.statut">
                    <input type="checkbox" class="custom-control-input" :value="data.item" :data-item="JSON.stringify(data.item)" checked :id="'item'+data.item.id" name="selected" v-model="selected" @change="check($event)">
                    <label class="custom-control-label" :for="'item'+data.item.id"></label>
                  </div>
                </template>
                <template v-slot:cell(action)="data" v-else>
                  <span v-if="data.item.etat_validation_souscripteur" class="text-success"><i class="fa fa-check fa-2x green-text" aria-hidden="true"></i></span>
                  <span v-else class="text-danger"><i class="fa fa-times fa-2x" aria-hidden="true"></i></span>
                </template>

                <!-- Optional default data cell scoped slot -->
                <template v-slot:cell()="data">
                  <p class="mb-0">{{ data.value }}</p>
                </template>

                <template>
                  <b-tr class="bg-primary text-white table_assureur">
                    <b-th class="align-middle">
                      <p class="mb-0 text-center total-label">
                        {{ $t("message.totaux") }}
                      </p>
                    </b-th>
                    <b-th>
                        <p class="mb-0 text-right">
                            {{ displayNumber(totalPrestationValider) }}
                        </p>
                    </b-th>
                     <b-th>
                        <p class="mb-0 text-right">
                            <!-- {{ displayNumber(totalPrestationValider - netAPayer) }} <br/> -->
                          <strong variant="primary">
                            {{ displayNumber(netAPayer) }}</strong>
                        </p>
                    </b-th>
                  </b-tr>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <div class="card-body items_1" v-for="(examen, index) in examens" :key="index">
              <div class="list-group-item"><p class="ligne justify-content-between"><span class="text-gray">NOM DE LA PRESTATION :</span>
                <span class="font-weight-bold new-title ">
                {{ examen.name }}
                </span></p>
              </div>
              <div class="list-group-item"><p class="ligne text-gray" ><span>PRIX</span>: 
                   <span class="font-weight-bold new-title med_bilan">
                      {{ displayNumber(examen.price) }}
                    </span></p>
              </div>
              <div :class="examen.statut == true ? 'statut_1' : 'statut_0'" class="list-group-item"><p class="ligne">
                <span>ACTION</span>:
                <span class="form-check med_bilan"  :class="activeTabIsexam() && examen.statut == true ? 'd-block' : 'd-none'">
                      <input class="form-check-input" type="checkbox" :value="examen" :data-item="JSON.stringify(examen)" checked :id="'item'+examen.id" name="selected" v-model="selected" @change="check($event)">
                      <label class="form-check-label" :for="'item'+examen.id">
                      </label>
                </span>
                
                <span class="font-weight-bold text-gray med_bilan" :class="activeTabIsexam() ? 'd-none' : 'd-block'">
                    <span class="text-success" v-if="examen.etat_validation_souscripteur"><i class="fa fa-check green-text" aria-hidden="true"></i></span>
                    <span class="text-danger" v-else><i class="fa fa-times" aria-hidden="true"></i></span>
                </span></p>
            </div>
        </div>
        <div class="card-body items_1">
                <div class="list-group-item">
                  <p class="ligne justify-content-between"><span class="font-weight-bold text-gray">Totaux </span>
                      </p>
                </div>
                <div class="list-group-item">
                  <p class="ligne justify-content-between"><span class="font-weight-bold text-gray">Total géneral </span>:
                      <span class="font-weight-bold new-title med_bilan">
                      {{ displayNumber(totalPrestationValider) }}
                      </span></p>
                </div>
                <div class="list-group-item">
                  <p class="ligne justify-content-between "><span class="font-weight-bold text-gray ">Total Souscripteur </span>:
                      <span class="font-weight-bold new-title med_bilan">
                      {{ displayNumber(netAPayer) }}
                      </span></p>
                </div>
        </div>
        </div>

          <div class="justify-content-sm-center"
            v-if="hasMedecinControleRole || hasSouscripteurRole"
          >

          <div class="row justify-content-center p-2">
               <span class="border-primary text-center font-weight-bold" v-if="hasSouscripteurRole">
                <h4 class="p-2 text-dark d-inline">Montant Net:</h4><h4 class="p-2 text-primary d-inline">{{ displayNumber(netAPayer) }}</h4> </span
              >
          </div>

          <div class="row justify-content-center p-2">
          <!-- //v-if="this.$route.params.view" -->
            <b-button @click="updateFacture" variant="primary" v-if="this.$route.query.activeTab == 'examen'"> 
              {{ $t("message.save") }}
  
              <!-- {{this.$route.query.activeTab}} -->
            </b-button>
            </div>
          </div>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";
import i18n from "@/plugins/i18n";

export default {
  name: "Show",

  computed: {
    ...mapGetters([
      "hasAdminRole",
      "isComptable",
      "validation_prix",
      "hasGestionnaireRole",
      "hasMedecinControleRole",
      "hasSouscripteurRole",
      "hasAssistante",
    ]),

    examensField: function () {
      let fArray = [
        { key: "name", label: i18n.t("message.nomPrestation") },
        { key: "price", label: i18n.t("message.price") },
      ];
      if (this.can) {
        fArray.push({ key: "Action", label: i18n.tc("message.action", 1) });
      }
      return fArray;
    },

    can: function () {
      return (
        this.hasAdminRole ||
        this.hasGestionnaireRole ||
        this.hasMedecinControleRole ||
        this.isComptable ||
        this.hasAssistante || this.hasSouscripteurRole
      );
    },

    mFacture: function () {
      return this.validation_prix;
    },

    etablissement: function () {
      if (this.mFacture.length > 0) {
        return this.mFacture[0].etablissement.name;
      }
      return "";
    },

    patientName: function () {
      if (this.mFacture.length > 0) {
        return this.mFacture[0].consultation.dossier.patient.user.nom + ' ' + this.mFacture[0].consultation.dossier.patient.user.prenom;
      }
      return "";
    },

    totalPrestationValider: function () {
      let total = 0;

      _.forEach(this.examens, function (prestation) {
          total += parseFloat(prestation.price);
      });

      return total;
    },

    netAPayer: function () {
      return this.selected.map(item => item.price).reduce((prev, curr) => prev + curr, 0);
    },

    examens: function () {
      let arrs = [];
      let examen_valider = [];
      _.forEach(this.mFacture, function (item) {
        //console.log(item)
        arrs.push({
          id: item.id,
          consultation:item.consultation_general_id,
          name: item.examen_complementaire.fr_description,
          price:
            item.examen_complementaire.examen_complementaire_prix.length > 0
              ? item.examen_complementaire.examen_complementaire_prix[0].prix
              : 0,
          statut: item.etat_validation_medecin === 1 ? true : false,
          etat_validation_souscripteur: item.etat_validation_souscripteur,
          _rowVariant: item.etat_validation_medecin === 1 ? "" : "danger",
          motif:
            item.etat_validation_souscripteur == null &&
            item.etat_validation_souscripteur
              ? item.etat_validation_souscripteur
              : "",
        });
        if (item.etat_validation_souscripteur === 1) {
          examen_valider = [...examen_valider, {
            id: item.id,
            consultation:item.consultation_general_id,
            name: item.examen_complementaire.fr_description,
            price: item.examen_complementaire.examen_complementaire_prix.length > 0 ? item.examen_complementaire.examen_complementaire_prix[0].prix : 0,
            statut: item.etat_validation_medecin === 1 ? true : false,
            etat_validation_souscripteur: item.etat_validation_souscripteur,
            _rowVariant: item.etat_validation_medecin === 1 ? "" : "danger",
            motif: item.etat_validation_souscripteur == null && item.etat_validation_souscripteur ? item.etat_validation_souscripteur : "",
          }];
        }
      });
      this.selected = examen_valider;
      return arrs;
    },
  },

  data() {
    return {
      consultation_id: this.$route.params.consultation != null ? this.$route.params.consultation : localStorage.getItem('consultation_id'),
      // view: this.$route.params.view != null ? this.$route.params.consultation : localStorage.getItem('view'),
      selected: [],
      mobileView: true,
      paginationOptions: {
        enabled: true,
        mode: "records",
        perPageDropdown: [10, 15, 20],
      },
    };
  },

  methods: {
    activeTabIsexam: function(){
      if (this.$route.query.activeTab == 'examen'){
        return true;
      }
      return false;
    },
    handleView() {
            this.mobileView = window.innerWidth < 991;
        },
    displayNumber(value) {
      return Number(value).toLocaleString("fr") + " FCFA";
    },
    examenComplementaire: function () {
     
      let args = {
        consultation: this.$route.params.consultation != null ? this.$route.params.consultation : localStorage.getItem('consultation_id')
      };

      localStorage.setItem('consultation_id',args.consultation);

      this.$store.dispatch("getExamenComplementaireValidation", { args });
    },
    getColorStatus(status) {
      switch (status) {
        case "Initié":
          return "--primary";
      }
    },

    check(e) {    
      let currentItem = JSON.parse(e.target.dataset.item);    
      if(!e.target.checked){
        this.selected = this.selected.filter(item => item.id != currentItem.id);
      }
    }, 

    getStatut(item) {
      if (item == "Validé") return "Facture validée par le Médecin control";
      else if (item == "Rejeté") return "Facture rejetée par le MC";
      else if (item == "Archivé")
        return "Facture destinée au Module de Comptabilité Interne de Medsurlink";
      else return "En attente de validation";
    },
    ImprimerFacture() {
      let args = {
        facture: this.facture_id,
      };

      this.$store.dispatch("printFacture", { args });
    },

    ImprimerFactureProforma() {
      let args = {
        facture: this.facture_id,
      };

      this.$store.dispatch("printFactureProforma", { args });
    },

    updateFacture() {
      
      // console.log(this.selected)
      let args = {
        examens: this.selected,
      };

      let successMessage = this.$i18n.t("message.ExamenPrixupdated");
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.error"),
      };
      this.$store.dispatch("setEtatValidationExamensSouscripteur", {
        args,
        successMessage,
        errorMessages,
      });
    },

    formattedDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    getFacture() {
      let args = {
        facture: this.facture_id,
      };
      this.$store.dispatch("getFacture", { args });
    },

    deleteFacture() {
      let args = {
        facture: this.facture_id,
      };

      let successMessage = this.$i18n.t("message.factureDeleted");
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.error"),
      };

      this.$store.dispatch("deleteFacture", {
        args,
        successMessage,
        errorMessages,
      });
    },

    mailRecouvrementFacture() {
      let args = {
        facture: this.facture_id,
      };

      let successMessage = this.$i18n.t("message.mailEnvoye");
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.error"),
      };

      this.$store.dispatch("mailRecouvrementFacture", {
        args,
        successMessage,
        errorMessages,
      });
    },

    mailRappelFacture() {
      let args = {
        facture: this.facture_id,
      };

      let successMessage = this.$i18n.t("message.mailEnvoye");
      let errorMessages = {
        generic: this.$i18n.t("message.genericError"),
        error: this.$i18n.t("message.error"),
      };

      this.$store.dispatch("mailRappelFacture", {
        args,
        successMessage,
        errorMessages,
      });
    },
  },
  created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
    },
  mounted() {
    this.examenComplementaire();
  },
};
</script>

<style scoped lang="scss">
$primary-color: #2dcecc;

p {
  font-size: 0.9rem !important;
}

.timeline-box {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2) !important;
  .box-title {
    i {
      color: $primary-color !important;
    }
  }
}

.total-label {
  font-size: 0.65rem !important;
  letter-spacing: 1px;
  font-weight: 600 !important;
  text-transform: uppercase;
}

.first-operation {
  position: relative;

  &:after {
    content: "";
    position: absolute;
    width: 8px;
    height: 1px;
    background: black;
    left: -28px;
    top: 150%;
  }
}

.last-operation {
  position: relative;
  &:after {
    $width: 130%;

    content: "";
    height: 4px;
    width: $width;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    position: relative;
    left: -10px;
    /*left: calc(50%);*/
    /*bottom: -.575rem;*/
    display: block;
  }
}

.total-amount {
  position: relative;

  &:before {
    content: "";
    height: 4px;
    width: 130%;
    border-top: 1px solid $primary-color;
    border-bottom: 1px solid $primary-color;
    position: relative;
    right: 10%;
    top: -8px;
    /*bottom: -.575rem;*/
    display: block;
  }
}

.custom-badge {
  $background-outer: #ebebebd6;
  $background-inner: $primary-color;

  /*.t {
      $background-inner: red;
  }*/

  display: inline-block;
  justify-content: space-between;
  align-items: center;
  border-radius: 30px;
  padding: 3px;
  color: #f4f4f4 !important;
  background: $background-outer;
  border: 0.5px solid $background-inner;
  /*border: 4px solid #f4f4f4;*/

  .left {
    margin-left: 0.7rem;
    /*line-height: .9;*/
  }

  .right {
    width: 80%;
    background: $background-inner;
    border-radius: 4rem;
    padding: 3px 15px;
    /*box-shadow: inset 4px 0 3px 3px rgba(0,0,0,.5);*/
    /*text-shadow: 0 5px 5px #000;*/
    font-size: 13px;
    text-align: center;
    letter-spacing: 1.1px;
    font-weight: 500;
  }
}

.custom-badge-1 {
  $background-outer: #ebebebd6;
  $background-inner: $primary-color;
  $color: #f4f4f4;

  background: $background-inner;
  color: $color;
  border-radius: 4rem;
  font-size: 13px;
  text-align: center;
  letter-spacing: 1.1px;
  font-weight: 500;
  position: relative;
  padding: 3px 15px 3px 20px;
  cursor: pointer;

  &:before {
    $dimension: 9px;

    content: "";
    width: $dimension;
    height: $dimension;
    border-radius: 50%;
    background: white;
    /*border: 1px solid $color;*/
    position: absolute;
    left: 7px;
    top: 6px;
  }

  &:hover {
    background: white;
    border: 1px solid $background-inner;
    color: $background-inner;

    &:before {
      background: $background-inner;
    }
  }
}
</style>
